import { Button } from '@components/Elements/Button'
import { Icon } from '@components/Elements/Icon'
import { Text } from '@components/Elements/Text'
import { api } from '@lib/api'
import { config } from '@lib/config'
import { useDebounce } from '@lib/hooks'
import { useI18n } from '@lib/i18n'
import { openExternalLink } from '@lib/linking'
import { Colors } from '@vetahealth/fishing-gear/colors'
import React from 'react'
import { ButtonWrapper, IconWrapper, Wrapper } from './styles'

export function GarminStart(): React.ReactNode {
  const t = useI18n()
  const handleGarminLogin = useDebounce(async () => {
    const garminResponse = await api.startGarminOAuth()

    if (garminResponse) {
      const url = new URL(config.garminOAuthUrl)
      url.searchParams.append('oauth_token', garminResponse.oauthToken)
      url.searchParams.append('oauth_callback', config.garminOAuthCallbackUrl)
      openExternalLink(url.toString())
    }
  })

  return (
    <Wrapper>
      <IconWrapper>
        <Icon icon={['fad', 'watch-fitness']} color={Colors.mauve600} size={60} />
      </IconWrapper>
      <Text weight="medium">{t('settings.garmin.connectExplanation')}</Text>
      <Text weight="medium">{t('settings.garmin.connectGarmin')}</Text>
      <ButtonWrapper>
        <Button label={t('settings.garmin.login')} variant="primary" onPress={handleGarminLogin} />
      </ButtonWrapper>
    </Wrapper>
  )
}
